import { Box, Chip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { getPlansOverviewRoute, getPlansRoute, isCurrentRoute } from "../../../routers/routeUtils";

const BillingHeaderNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation("plans", { keyPrefix: "component.billingHeaderNav" });
  const tabs = [
    {
      label: t("overview"),
      route: getPlansOverviewRoute(),
    },
    {
      label: t("plans"),
      route: getPlansRoute(),
    },
  ];

  return (
    <>
      <Box sx={styles.header}>
        <Typography variant="h3" sx={styles.headerTitle}>
          {t("manageYourSubscription")}
        </Typography>
        <Typography sx={styles.headerDescription}>{t("manageYourSubscriptionDescription")}</Typography>
      </Box>
      <Box sx={styles.container}>
        {tabs.map((tab, idx) => {
          const isCurrent = isCurrentRoute(location.pathname, tab.route);
          const hasBorderRight = idx !== tabs.length - 1;
          return (
            <Chip
              key={tab.route}
              label={tab.label}
              variant="outlined"
              sx={styles.chip(isCurrent, hasBorderRight)}
              onClick={() => navigate(tab.route)}
            />
          );
        })}
      </Box>
    </>
  );
};

export default BillingHeaderNav;

const styles = {
  header: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  headerTitle: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "30px",
  },
  headerDescription: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  container: {
    display: "flex",
    border: "1px solid #D0D5DD",
    height: "fit-content",
    width: "fit-content",
    borderRadius: "8px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    overflow: "hidden",
  },
  chip: (isCurrent: boolean, hasBorderRight: boolean) => ({
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    border: "none",
    borderRadius: "0",
    padding: "10px 16px",
    color: isCurrent ? "var(--Green---100, #008B07)" : "var(--Gray-700, #344054)",
    backgroundColor: isCurrent ? "#F0F5F4" : "var(--Base-White, #FFF)",
    borderRight: hasBorderRight ? "1px solid #D0D5DD" : "",
    "& .MuiChip-label": {
      padding: 0,
    },
  }),
};
